import {
    Main
} from './class/page-sub.js';

var APP = new Main();
APP.init();